import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BellRing, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useMe } from "@/context/MeContext";
import { errMsg, useApi } from "@/lib/api";

export function WatchButton({ result }) {
  const { isSignedIn } = useMe();
  const api = useApi();
  const navigate = useNavigate();
  const [state, setState] = useState("idle");

  useEffect(() => {
    if (!isSignedIn) return;
    api("get", "/me/watches").then((ws) => ws.some((w) => w.url === result.url) && setState("done")).catch(() => {});
  }, [isSignedIn, api, result.url]);

  const watch = async () => {
    if (!isSignedIn) return navigate("/sign-in");
    setState("busy");
    try {
      await api("post", "/watches", { search_id: result.id });
      setState("done");
      toast.success("Fatto! Ti avviseremo via email (e SMS) se il prezzo scende.");
    } catch (e) {
      if (e?.response?.status === 409) setState("done");
      else setState("idle");
      toast.error(errMsg(e));
    }
  };

  return (
    <button
      data-testid="watch-price-btn"
      onClick={watch}
      disabled={state !== "idle"}
      className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl border border-sky-400/40 px-4 py-3 text-sm font-semibold text-sky-300 transition-colors hover:bg-sky-400/10 disabled:opacity-70"
    >
      {state === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : state === "done" ? <Check className="h-4 w-4" /> : <BellRing className="h-4 w-4" />}
      {state === "done" ? "Prodotto seguito" : "Avvisami se il prezzo scende"}
    </button>
  );
}
